<template>
    <div 
        :id="gtmTrackerId"
        class="general-list tag-list pt-4"
        :class="{ 'px-3': isAlternativeMode }"
    >
        <div
            class="tag"
            v-for="(filterItem, index) in filterData"
            :key="filterItem.id + index"
            :class="{ 'inactive': !filterItem.active }"
            :style="{ 'background-color': filterItem.color }"
        >
            <BadgeItem
                :filterItem="filterItem"
                @filter-method="filterBy"
            />
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import BadgeItem from "@/components/filters/BadgeItem";

    export default {
        name: "BadgeItems",
        components: {
            BadgeItem
        },
        props: {
            filterData: {
                type: [Object, Array],
                required: true,
            },
            filterType: {
                type: String,
                required: true,
            }
        },
        computed: {
            ...mapGetters([
                'isAlternativeMode'
            ]),
            gtmTrackerId() {
                return `gtm-filter-${this.$props.filterType}`;
            }
        },
        methods: {
            filterBy(filter) {
                this.$emit('filter-method', filter);
            }
        }
    }
</script>

<style lang="scss">
    @import "@/assets/scss/components/_tags.scss";
</style>


// WEBPACK FOOTER //
// src/components/filters/BadgeItems.vue